import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)({
  display: 'grid',
  alignContent: 'center',
  justifyItems: 'center',
  minWidth: 'fit-content',
  height: '100%',
});
